<template>
  <div class="storedropdown field mb-0 ms-0" :title="disabled == true ? model?.Name : ''">
    <label path="storeid">{{ label }} <span class="red" v-if="requiredIcon">*</span></label>
    <!-- {{ StoreDropDown.StoreOption }} -->
    <!-- {{ model }} -->

    <!-- {{ filterId }}
    {{ storetype }} -->
    <Dropdown v-model="model" :type="type" :disabled="disabled" :filter="filter" :options="StoreDropDown.StoreOption"
      optionLabel="Name" :key-field="valueField" :label-field="textField"
      :class="{ 'p-invalid': errorMessages.length, styleclass }" @change="$.emit('change')" @update:model-value="input"
      :id="id" :showClear="showClear" class="w-full md:w-14rem" :placeholder="placeholder" :tabindex="tabindex"
      :auto-filter-focus="true" :title="model?.Name" ref="dropdownref">
      <template v-slot:option="option">
        <!-- {{ option }} -->
        <div class="flex align-items-center">
          <span v-if="option.option.StoreTypeName == 'Main Store'" class="main-store">MS</span>
          <span v-if="option.option.StoreTypeName == 'Sub Store'" class="Sub-store">SS</span>
          <span v-if="option.option.StoreTypeName == 'Department Store'" class="dep-store">DS</span>
          <span v-if="option.option.StoreTypeName == 'Sub Department Store'" class="dep-store">SD</span>
          <div>{{ option.option.Name }}</div>
        </div>
      </template>
    </Dropdown>
    <span v-if="errorMessages.length" class="err_msg_style">{{
      errorMessages[0]
    }}</span>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
  nextTick,
} from "vue";
import { useField, defineRule, configure, validate } from "vee-validate";
import { required, email } from "@vee-validate/rules";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import commonservice from "../../Service/StoreService";

const profilelist = [
  {
    label: "Admin",
    key: "jay gatsby",
  },
  {
    label: "Daisy Buchanan",
    key: "daisy buchanan",
  },
  {
    type: "divider",
    key: "d1",
  },
  {
    label: "Nick Carraway",
    key: "nick carraway",
  },
  {
    label: "Others",
    key: "others1",
    children: [
      {
        label: "Jordan Baker",
        key: "jordan baker",
      },
      {
        label: "Tom Buchanan",
        key: "tom buchanan",
      },
      {
        label: "Others",
        key: "others2",
        children: [
          {
            label: "Chicken",
            key: "chicken",
          },
          {
            label: "Beef",
            key: "beef",
          },
        ],
      },
    ],
  },
];

export default defineComponent({
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Boolean,
      default: true,
    },
    showClear: {
      type: Boolean,
      default: true,
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    // modelValue: {},
    textField: {
      type: String,
      default: "name",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    valueField: {
      type: String,
      default: "value",
    },
    vid: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    storetype: {
      type: Number,
      default: 0,
    },
    filterId: {
      type: Number,
      default: 0,
    },
    storeStatus: {
      type: Number,
      default: 0,
    },
    storeFilterStatus: {
      type: Number,
      default: 0,
    },

    invalid: {
      type: String,
      default: "This field is required",
    },
    modelValue: {
      type: [String, Number, Object, Boolean, Array],
      default: null,
    },
    requiredIcon: {
      type: Boolean,
      defalut: false,
    },
    styleclass: {
      type: String,
      default: "",
    },
    tabindex: {
      type: Number,
    },
    tostorefilter: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    const router = useRouter();
    const QueryString = useRoute();
    let storedata = ref("");
    let SelectedStore: any = ref();
    const dropdownref: any = ref(null);
    let List = ref([]);

    onMounted(() => {
      LoadStore();
      model.value = props.modelValue;
      input();
    });

    //Load Store Drop Down
    let StoreDropDown: any = ref({
      StoreOption: [],
      StoreId: ref(),
    });

    let data = "";
    let FromStoreBranchId = 0;

    if (QueryString.query.data) {
      data = QueryString.query.data as string;
      const QueryData = JSON.parse(data);
      FromStoreBranchId = QueryData["BranchId"];
    }

    //Load Store Drop down
    async function LoadStore() {
      debugger;
      let result: any = null;
      let fromresult: any = null;

      try {
        // Get store list based on filter status
        if (props.storeFilterStatus == 0) {
          // result = await commonservice.getStoreListByUserId(
          //   usersData.UserId,
          //   usersData.OrganizationId,
          //   usersData.Admin,
          //   usersData.BranchId
          // );
          // alert("storeFilterStatus 0");
          result = await commonservice.StoreDropDownListByUserId(
            usersData.UserId,
            usersData.OrganizationId,
            usersData.Admin,
            usersData.BranchId
          );
          debugger;
        } else if (props.storeFilterStatus == 2) {

          // result = await commonservice.GetAllStoreList(
          //   usersData.OrganizationId,
          //   "0"
          // );
          result = await commonservice.StoreDropDownListCustomForUserCreate(
            usersData.OrganizationId,
            "0"
          );

          result["result"] = result["result"]
            .filter((x) => x.StoreTypeId == 1)
            .map((item) => {
              item.Name = item.Name + " - " + item.CurrentBranchName;
              return item;
            });
        } else {
          // result = await commonservice.GetAllStoreList(
          //   usersData.OrganizationId,
          //   "0"
          // );
          result = await commonservice.StoreDropDownListCustomForUserCreate(
            usersData.OrganizationId,
            "0"
          );

          result["result"] = result["result"].map((item) => {
            item.Name = item.Name + " - " + item.CurrentBranchName;
            return item;
          });
        }

        // Check if result is valid
        if (!result || !result["result"]) {
          console.error("No store results returned");
          return;
        }
      } catch (error) {
        console.error("Error loading stores:", error);
        return;
      }

      if (props.storetype == 0) {
        if (props.filterId == 0) {
          StoreDropDown.value.StoreOption = result["result"]
            .filter((x) => x.Id != props.filterId && x.IsActive == 1)
            .map((item) => {
              item.name = item.Name;
              item.value = item.StoreBranchMapId;
              item.Name = item.Name; //+ " - " + item.CurrentBranchName;
              item.Id = item.Id;
              item.StoreCode = item.Code;
              item.StoreTypeId = item.StoreTypeId;
              item.StoreTypeName = item.StoreTypeName;
              item.StoreBranchMapId = item.StoreBranchMapId;
              return item;
            });
        } else {
          if (props.filterId) {
            fromresult = await commonservice.getStoreByStoreId(
              props.filterId,
              usersData.OrganizationId,
              usersData.BranchId
            );
            StoreDropDown.value.StoreOption = fromresult["result"].map((item) => {
              item.name = item.Name;
              item.value = item.StoreBranchMapId;
              item.Name = item.Name;
              item.Id = item.Id;
              item.StoreCode = item.Code;
              item.StoreTypeId = item.StoreTypeId;
              item.StoreTypeName = item.StoreTypeName;
              item.StoreBranchMapId = item.StoreBranchMapId;
              return item;
            });
          }
        }
      } else {
        if (props.filterId != 0 && props.filterId != null) {
          if (props.storetype == 4) {
            StoreDropDown.value.StoreOption = result["result"]
              .filter((x) => x.Id != props.filterId && x.StoreTypeId != 1)
              .map((item) => {
                item.name = item.Name;
                item.value = item.StoreBranchMapId;
                item.Name = item.Name;
                item.Id = item.Id;
                item.StoreCode = item.Code;
                item.StoreTypeId = item.StoreTypeId;
                item.StoreTypeName = item.StoreTypeName;
                item.StoreBranchMapId = item.StoreBranchMapId;
                return item;
              });
          } else if (props.storetype == 5) {
            if (props.filterId) {
              fromresult = await commonservice.getStoreByStoreId(
                props.filterId,
                usersData.OrganizationId,
                usersData.BranchId
              );
              StoreDropDown.value.StoreOption = fromresult["result"]
                .filter((x) => x.StoreTypeId != 2)
                .map((item) => {
                  item.name = item.Name;
                  item.value = item.StoreBranchMapId;
                  item.Name = item.Name;
                  item.Id = item.Id;
                  item.StoreCode = item.Code;
                  item.StoreTypeId = item.StoreTypeId;
                  item.StoreTypeName = item.StoreTypeName;
                  item.StoreBranchMapId = item.StoreBranchMapId;
                  return item;
                });
            }

          } else if (props.storetype == 6) {
            if (props.filterId) {
              fromresult = await commonservice.getStoreByStoreId(
                props.filterId,
                usersData.OrganizationId,
                FromStoreBranchId
              );

              StoreDropDown.value.StoreOption = fromresult["result"]
                .map((item) => {
                  item.name = item.Name;
                  item.value = item.StoreBranchMapId;
                  item.Name = item.Name;
                  item.Id = item.Id;
                  item.StoreCode = item.Code;
                  item.StoreTypeId = item.StoreTypeId;
                  item.StoreTypeName = item.StoreTypeName;
                  item.StoreBranchMapId = item.StoreBranchMapId;
                  return item;
                });
            }
          } else if (props.storetype == 7) {
            if (props.filterId) {
              fromresult = await commonservice.getStoreByStoreId(
                props.filterId,
                usersData.OrganizationId,
                usersData.BranchId
              );
              StoreDropDown.value.StoreOption = fromresult["result"]
                .filter(
                  (x) => x.StoreTypeId == 1 && x.BranchId != usersData.BranchId
                )
                .map((item) => {
                  item.name = item.Name;
                  item.value = item.StoreBranchMapId;
                  item.Name = item.Name;
                  item.Id = item.Id;
                  item.StoreCode = item.Code;
                  item.StoreTypeId = item.StoreTypeId;
                  item.StoreTypeName = item.StoreTypeName;
                  item.StoreBranchMapId = item.StoreBranchMapId;
                  return item;
                });
            }
          } else if (props.storetype == 8) {
            if (props.filterId) {
              fromresult = await commonservice.getStoreByStoreId(
                props.filterId,
                usersData.OrganizationId,
                usersData.BranchId
              );
              StoreDropDown.value.StoreOption = fromresult["result"]
                .filter((x) => x.StoreTypeId == 1)
                .map((item) => {
                  item.name = item.Name;
                  item.value = item.StoreBranchMapId;
                  item.Name = item.Name;
                  item.Id = item.Id;
                  item.StoreCode = item.Code;
                  item.StoreTypeId = item.StoreTypeId;
                  item.StoreTypeName = item.StoreTypeName;
                  item.StoreBranchMapId = item.StoreBranchMapId;
                  return item;
                });
            }
          } else if (props.storetype == 9) {
            if (props.filterId) {
              fromresult = await commonservice.getStoreByStoreId(
                props.filterId,
                usersData.OrganizationId,
                usersData.BranchId
              );
              StoreDropDown.value.StoreOption = fromresult["result"]
                .map((item) => {
                  item.name = item.Name;
                  item.value = item.StoreBranchMapId;
                  item.Name = item.Name;
                  item.Id = item.Id;
                  item.StoreCode = item.Code;
                  item.StoreTypeId = item.StoreTypeId;
                  item.StoreTypeName = item.StoreTypeName;
                  item.StoreBranchMapId = item.StoreBranchMapId;
                  return item;
                });
            }
          } else if (props.storetype == 10) {
            if (props.filterId) {
              fromresult = await commonservice.getStoreByStoreId(
                props.filterId,
                usersData.OrganizationId,
                usersData.BranchId
              );
              if (props.storeStatus == 1) {
                StoreDropDown.value.StoreOption = fromresult["result"]
                  .filter((x) => x.StoreTypeId == 1)
                  .map((item) => {
                    item.name = item.Name;
                    item.value = item.StoreBranchMapId;
                    item.Name = item.Name;
                    item.Id = item.Id;
                    item.StoreCode = item.Code;
                    item.StoreTypeId = item.StoreTypeId;
                    item.StoreTypeName = item.StoreTypeName;
                    item.StoreBranchMapId = item.StoreBranchMapId;
                    return item;
                  });
              } else if (props.storeStatus == 2) {
                StoreDropDown.value.StoreOption = fromresult["result"]
                  .filter((x) => x.StoreTypeId != 1)
                  .map((item) => {
                    item.name = item.Name;
                    item.value = item.StoreBranchMapId;
                    item.Name = item.Name;
                    item.Id = item.Id;
                    item.StoreCode = item.Code;
                    item.StoreTypeId = item.StoreTypeId;
                    item.StoreTypeName = item.StoreTypeName;
                    item.StoreBranchMapId = item.StoreBranchMapId;
                    return item;
                  });
              } else if (props.storeStatus == 3) {
                StoreDropDown.value.StoreOption = fromresult["result"]
                  .filter((x) => x.StoreTypeId == 3)
                  .map((item) => {
                    item.name = item.Name;
                    item.value = item.StoreBranchMapId;
                    item.Name = item.Name;
                    item.Id = item.Id;
                    item.StoreCode = item.Code;
                    item.StoreTypeId = item.StoreTypeId;
                    item.StoreTypeName = item.StoreTypeName;
                    item.StoreBranchMapId = item.StoreBranchMapId;
                    return item;
                  });
              }
            }
          }
        } else {
          if (props.storetype) {
            StoreDropDown.value.StoreOption = result["result"]
              .filter((x) => x.StoreTypeId == props.storetype)
              .map((item) => {
                item.name = item.Name;
                item.value = item.StoreBranchMapId;
                item.Name = item.Name;
                item.Id = item.Id;
                item.StoreCode = item.Code;
                item.StoreTypeId = item.StoreTypeId;
                item.StoreTypeName = item.StoreTypeName;
                item.StoreBranchMapId = item.StoreBranchMapId;
                return item;
              });
          }
        }
      }

      // Sort the StoreOption array alphabetically by Name
      StoreDropDown.value.StoreOption.sort((a: any, b: any) => {
        const nameA = typeof a.Name === "string" ? a.Name.toLowerCase() : "";
        const nameB = typeof b.Name === "string" ? b.Name.toLowerCase() : "";
        return nameA.localeCompare(nameB);
      });
      emit("StoreOptions", StoreDropDown.value.StoreOption);
    }

    function navigate() {
      debugger;
    }

    const model = ref();



    function input() {
      emit("update:modelValue", model.value);
    }

    watch(
      () => props.filterId,
      (newVal) => {
        LoadStore();
      }
    );

    watch(
      () => props.modelValue,
      (newVal) => {
        let foundItem: any;

        // If StoreDropDown.value.StoreOption is empty, return early
        if (!StoreDropDown.value.StoreOption || StoreDropDown.value.StoreOption.length === 0) {
          return;
        }

        if (newVal == null) {
          // If newVal is null, don't try to find anything
          foundItem = null;
        } else if (props.disabled == true) {
          // If dropdown is disabled, find by StoreBranchMapId directly
          foundItem = StoreDropDown.value.StoreOption.find(
            (item) => item.StoreBranchMapId === props.modelValue
          );
        } else if (QueryString.path == "/POCreation") {
          // Special case for POCreation path
          if (typeof newVal === 'object' && newVal !== null && newVal["StoreBranchMapId"] != null) {
            foundItem = StoreDropDown.value.StoreOption.find(
              (item) => item.StoreBranchMapId === newVal["StoreBranchMapId"]
            );
          } else {
            foundItem = StoreDropDown.value.StoreOption.find(
              (item) => item.StoreBranchMapId === newVal
            );
          }
        } else {
          // For other paths
          if (typeof newVal === 'object' && newVal !== null && newVal["StoreBranchMapId"] != null) {
            foundItem = StoreDropDown.value.StoreOption.find(
              (item) => item.StoreBranchMapId === newVal["StoreBranchMapId"]
            );
          } else {
            foundItem = StoreDropDown.value.StoreOption.find(
              (item) => item.StoreBranchMapId === newVal
            );
          }
        }

        model.value = foundItem;
      }
    );

    watch(
      () => StoreDropDown.value.StoreOption,
      (newVal) => {
        if (!StoreDropDown.value.StoreOption || StoreDropDown.value.StoreOption.length === 0) {
          return;
        }

        let foundItem = null;

        if (props.modelValue) {
          if (typeof props.modelValue === 'object' && props.modelValue !== null && props.modelValue["StoreBranchMapId"] != null) {
            foundItem = StoreDropDown.value.StoreOption.find(
              (item) => item.StoreBranchMapId === props.modelValue["StoreBranchMapId"]
            );
          } else {
            foundItem = StoreDropDown.value.StoreOption.find(
              (item) => item.StoreBranchMapId === props.modelValue
            );
          }
        }

        if (foundItem) {
          model.value = foundItem;
          emit("update", model.value);
        }
      }
    );

    const { value, errorMessage, handleBlur, handleChange } = useField(
      props.name,
      props.rules,
      { initialValue: props.modelValue }
    );

    const errorMessages = computed(() => {
      return errorMessage.value ? [errorMessage.value] : [];
    });

    const fieldClass = computed(() => {
      return {
        "is-invalid": errorMessages.value.length > 0,
      };
    });

    const highlightMatch = (option) => {
      let name = option.name;
      console.log(dropdownref.value);
      const regex = new RegExp(`(${dropdownref.value.filterValue})`, "gi");
      return name.replace(regex, '<span class="highlight">$1</span>');
    };

    return {
      input,
      model,
      errorMessages,
      handleBlur,
      fieldClass,
      highlightMatch,
      dropdownref,
      List,
      navigate,
      storedata,
      StoreDropDown,
      SelectedStore,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../../../assets/variables.scss";

.p-dropdown {
  align-items: center;
  width: 100%;
  // background: $HeaderBg !important;
  border: 1px solid #ced4da;
  //transition: background-color 0.2s, color 0.2s, border-color 0.2s,
  //box-shadow 0.2s;
  border-radius: 6px;
  //margin-left: 20px;
  height: 40px;
}

.p-dropdown-panel .p-dropdown-items {
  padding: 0.75rem 0;
  background-color: black !important;
}

.p-dropdown-items-wrapper {
  overflow: auto;
  background-color: black !important;
}

.p-dropdown-items-wrapper ul li div {
  width: 150px;
  display: flex;
}

.p-dropdown-items {
  background-color: black !important;
}

.p-dropdown-label div {
  color: black;
  display: flex;
  width: 150px;
}

.p-dropdown-panel {
  background: #000000 !important;
  color: #495057;
  border: 0 none;
  border-radius: 6px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
  color: #495057;
  background: #000000 !important;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  color: #fdfdfd !important;
  background: #040404 !important;
}

.main-store {
  color: #000000;
  font-size: 10px;
  border-radius: 50%;
  background-color: #cdd0fb;
  padding: 10px;
  // width: 120px;
  // height: 120px;
  margin-right: 10px;
}

.Sub-store {
  color: #000000;

  font-size: 10px;
  border-radius: 50%;
  background-color: #fff3cc;
  padding: 10px;
  // width: 120px;
  // height: 120px;
  margin-right: 10px;
}

.dep-store {
  color: #000000;

  font-size: 10px;
  border-radius: 50%;
  background-color: #ffcccc;
  padding: 10px;
  // width: 120px;
  // height: 120px;
  margin-right: 10px;
}

.storedropdown .p-inputtext {
  padding: 0.3rem 0.75rem !important;
}

// .storedropdown .p-dropdown {
//   height: 40px;
//   width: 265px;
// }

.storedropdown .p-dropdown.active {
  border: 1px solid #0148e2 !important;
}

// @media only screen and (max-width: 575px) {
// .storedropdown .p-dropdown{
//   width: 250px;
// }

// }
@media only screen and (max-width: 430px) {
  // .storedropdown .p-dropdown {
  //width: 152px;
  //}
}
</style>
